import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'description-image' }>

export default function DescriptionImage(block: BlockProps): ReactElement {
  const { description, image } = block

  return (
    <Container>
      <Grid>
        <div className="col-span-full lg:col-span-6 border-t pt-4 md:pt-8 lg:pt-10 border-heading">
          <Text className="whitespace-pre-wrap" variant="body">
            {description}
          </Text>
        </div>

        <div className="group relative col-span-full lg:col-span-6 min-h-[280px] md:[min-h-300px] lg:min-h-[420px] xl:min-h-[500px]">
          <div className="absolute inset-0 z-10 bg-gradient-to-t from-black to-transparent opacity-80" />
          <Asset resource={image as AssetType} imgClassName="object-cover object-center" fill />
        </div>
      </Grid>
    </Container>
  )
}
